import { createAction } from '@reduxjs/toolkit'
import { type ReportQueryType } from './reports.type'

export const setQuery = createAction<Partial<ReportQueryType>>(
  'SET_REPORTING_QUERY'
)
